import React from 'react'
import { ErrorMessage, useFormikContext } from 'formik'

function CDInput({
  label,
  name,
  placeholder,
  type,
  required,
  className,
  rightIcon,
  onIconClick,
}) {
  const formik = useFormikContext()

  return (
    <div class={`signup-input ${className}`}>
      <div className='label '>
        {label}
        {required ? '*' : ''}
      </div>
      <div className='input-wrap tw-relative'>
        <input
          {...formik.getFieldProps(name)}
          type={type || 'text'}
          placeholder={placeholder}
          className={rightIcon ? 'tw-pr-10' : undefined}
        />
        {rightIcon && (
          <button
            type='button'
            onClick={onIconClick}
            className='tw-absolute tw-right-3 tw-top-1/2 tw--translate-y-1/2 tw-text-slate-400 tw-flex tw-items-center tw-justify-center'
          >
            {rightIcon}
          </button>
        )}
      </div>
      <ErrorMessage name={name} component='div' className='error' />
    </div>
  )
}

export default CDInput
